import { formatCryptoCurrency, formatWallet } from '@basqet-dashboard/common/utils';
import PropTypes from 'prop-types';
import React from 'react';

const TransactionDetails = ({ transaction, currencyName }) => {
  const { amount, fee, totalAmount, address, row_count } = transaction;

  return (
    <div className="transaction-details">
      <div className="transaction-details-item">
        <p>Amount:</p>
        <p className="text-right">
          {formatCryptoCurrency(amount)} {currencyName}
        </p>
      </div>
      <div className="transaction-details-item">
        <p>Fee:</p>
        <p className="text-right">
          {formatCryptoCurrency(fee)} {currencyName}
        </p>
      </div>
      <div className="transaction-details-item">
        <p>Total:</p>
        <p className="text-right text-bold">
          {formatCryptoCurrency(totalAmount)} {currencyName}
        </p>
      </div>
      {address && (
        <div className="transaction-details-item">
          <p>Address:</p>
          <p className="text-right">{formatWallet(address)}</p>
        </div>
      )}
      {row_count && (
        <div className="transaction-details-item">
          <p>Number of recipients:</p>
          <p className="text-right">{row_count}</p>
        </div>
      )}
    </div>
  );
};

TransactionDetails.propTypes = {
  transaction: PropTypes.object,
  currencyName: PropTypes.string
};
export { TransactionDetails };
